import { Box, FormControlLabel, Modal, Radio, RadioGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { RxCross1 } from "react-icons/rx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalSortProduct = ({ open, setOpen, reqBody, setReqBody }) => {
  const [tempSort, setTempSort] = useState("created_desc");

  const handleClose = () => {
    setTempSort(3);
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      setTempSort(reqBody.order_by);
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "hidden",
            overflowX: "wrap",
            maxHeight: "80vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-2/3 h-fit text-[#2C3E5D]"
        >
          <div className="flex justify-between items-center px-8 py-4">
            <p className="text-[18px]">Urutkan</p>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
          <div className="px-8 pb-4 overflow-y-auto overflow-x-hidden max-h-[40vh] ">
            <RadioGroup
              value={tempSort}
              onChange={(e) => setTempSort(e.target.value)}
            >
              {[
                {
                  id: "price_asc",
                  name: "Harga Terendah",
                },
                {
                  id: "price_desc",
                  name: "Harga Tertinggi",
                },
                { id: "name_asc", name: "Nama Produk A-Z" },
                { id: "name_desc", name: "Nama Produk Z-A" },
                { id: "created_desc", name: "Terbaru" },
              ].map((item, i) => (
                <FormControlLabel
                  value={item.id}
                  sx={{ width: "100%" }}
                  control={<Radio />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </div>

          <div className="flex justify-end items-center px-8 py-4 gap-2">
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#F1FAF0] text-[#6F955B] border-[#6F955B] hover:bg-gray-300"
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="border-2 py-2 px-4 rounded-md bg-[#6F955B] border-[#6F955B] text-white hover:bg-gray-300"
              onClick={() => {
                setReqBody((prevVal) => ({
                  ...prevVal,
                  order_by: tempSort,
                  offset: 1,
                }));
                handleClose();
              }}
            >
              Simpan
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalSortProduct;
